
const observer = new IntersectionObserver(entries => {
  var delay = 0;
  // Loop over the entries
  entries.forEach(entry => {
    // If the element is visible
    if (entry.isIntersecting) {
      // Add the animation class
      setTimeout(function () {
        entry.target.classList.remove('blm-lazyload');
        entry.target.classList.add('blm-lazyloaded');
      }, delay);

      delay += 300;
      observer.unobserve(entry.target);
    }
  });
},
{
  threshold: [1.0]
});


  const lazyloadItems = document.querySelectorAll('.blm-lazyload');
  lazyloadItems.forEach(lazyloadItem => observer.observe(lazyloadItem));
